import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m12 18-4.2 1.8q-1 .426-1.9-.163-.9-.587-.9-1.662V5q0-.824.588-1.413A1.93 1.93 0 0 1 7 3h10q.824 0 1.413.587.586.589.587 1.413v12.975q0 1.075-.9 1.662-.9.588-1.9.163zm0-2.2 5 2.15V5H7v12.95zM12 5H7h10z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }